import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

export default function TopbarName() {
  const [name, setName] = useState();
  const location = useLocation();
  const intl = useIntl();

  useEffect(() => {
    switch (location.pathname) {
      case '/home':
        setName(intl.formatMessage({ id: 'app.corporate.headTitle' }));
        break;
      case '/account':
        setName(intl.formatMessage({ id: 'app.barmenu.myAccount' }));
        break;
      case '/usersByCorps':
        setName(intl.formatMessage({ id: 'app.barmenu.users' }));
        break;
      case '/usersMetimur':
        setName(intl.formatMessage({ id: 'app.barmenu.metUsers' }));
        break;
      case '/roles':
        setName(intl.formatMessage({ id: 'app.barmenu.roles' }));
        break;
      case '/controlRate':
        setName(intl.formatMessage({ id: 'app.barmenu.feeCtrl' }));
        break;
      case '/notificationDashboard':
        setName(intl.formatMessage({ id: 'app.barmenu.alerts' }));
        break;
      case '/reports':
        setName(intl.formatMessage({ id: 'app.barmenu.reports' }));
        break;
      case '/invoices':
        setName('Recibos');
        break;
      case '/help':
        setName(intl.formatMessage({ id: 'app.barmenu.help' }));
        break;
      default:
        break;
    }
  }, [location.pathname]);

  return (
    <Typography sx={{ color: '#A53693' }} ml={1} variant="h3">
      {name}
    </Typography>
  );
}
